import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../../../../api-client";
import OnboardingKeys from "../queryKeys";
import { OnboardingTypes } from "../useOnboarding/useOnboarding.types";

const useOnboardingMarkAsSeen = () => {
  const queryClient = useQueryClient();
  const { put } = useApiClient();

  const markAsSeen = async (onboarding: OnboardingTypes) => {
    await put("/v1/employees/onboarding", { name: onboarding });
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [OnboardingKeys.ONBOARDING] });
  };

  return useMutation({ mutationFn: markAsSeen, onSuccess });
};

export default useOnboardingMarkAsSeen;
